import React, { Component } from 'react'

import { injectIntl } from 'react-intl'
import messages from './messages'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'

import CheckBoxFilter from 'modules/Filters/CheckBoxFilter'
import TypeAheadFilter from 'modules/Filters/TypeAheadFilter'
import EvolutionFilter from 'modules/Filters/EvolutionFilter'
import ChartTypeFilter from 'modules/Filters/ChartTypeFilter'
import FilterModal from 'modules/Filters/FilterModal'

import RegionTools from 'utils/regions/regionTools'

class FilterContainer extends Component {
  constructor(props) {
    super(props)

    const {
      intl: { formatMessage }
    } = props

    this.formatMessage = formatMessage

    this.state = {
      allRegions: true,
      referenceRegions: false,
      sameCountryRegions: false,
      otherRegions: [],
      yearsEvolution: 1,
      chartType: 'evolutionAbsolute',
      showAllRegionsModal: false,
      showReferenceRegionsModal: false
    }

    this.regionName = RegionTools.getRegionNameFromId({ regionsData: props.regionsData, id: props.selectedRegionId })

    this.tooltip = <Tooltip id="tooltip">{this.formatMessage(messages.tooltip)}</Tooltip>
  }

  componentDidMount() {
    this.props.manageAllFilter(this.state.allRegions)
    this.props.manageReferenceFilter(this.state.referenceRegions)
    this.props.manageSameCountryFilter(this.state.sameCountryRegions)
    this.props.manageTypeAheadFilter(this.state.otherRegions)
    this.props.manageEvolutionFilter(this.state.yearsEvolution)
    this.props.manageChartTypeFilter(this.state.chartType)
  }

	manageAll = checked => {
	  this.setState({ allRegions: checked })
	  this.props.manageAllFilter(checked)
	}

	manageReference = checked => {
	  this.setState({ referenceRegions: checked })
	  this.props.manageReferenceFilter(checked)
	}

	manageSameCountry = checked => {
	  this.setState({ sameCountryRegions: checked })
	  this.props.manageSameCountryFilter(checked)
	}

	manageTypeAhead = selected => {
	  this.setState({ otherRegions: selected })
	  this.props.manageTypeAheadFilter(selected)
	}

	manageEvolution = selected => {
	  this.setState({ evolution: selected })
	  this.props.manageEvolutionFilter(selected)
	}

	manageChartType = selected => {
	  this.setState({ chartType: selected })
	  this.props.manageChartTypeFilter(selected)
	}

	showAllRegionsFilter() {
	  const regionName = RegionTools.getRegionNameFromId({ regionsData: this.props.regionsData, id: this.props.selectedRegionId })
	  return (
	    <div className="ork-indicators-filters__col ork-indicators-filters__european-regions">
	      <OverlayTrigger placement="left" overlay={this.tooltip}>
	        <div className="ork-indicators-filters__col__more-info" onClick={this.openAllRegionsModal}>
	          <i className="fal fa-lg fa-info-circle" />
	        </div>
	      </OverlayTrigger>
	      <div className="checkbox">
	        <CheckBoxFilter label={this.formatMessage(messages.showAllRegions)} fn={this.manageAll} checked={this.state.allRegions} />
	      </div>
	      <FilterModal
	        type="all"
	        regionsData={this.props.regionsData}
	        open={this.state.showAllRegionsModal}
	        closeModal={this.closeAllRegionsModal}
	        regionName={regionName}
	      />
	    </div>
	  )
	}

	openAllRegionsModal = () => {
	  this.setState({ showAllRegionsModal: true })
	}
	closeAllRegionsModal = () => {
	  this.setState({ showAllRegionsModal: false })
	}

	showReferenceRegionsFilter() {
		// FIX: disabled referene regions
	  const regionsData = []; // this.props.referenceRegionsData.filter(region => region.id !== this.props.selectedRegionId)
	  const regionName = RegionTools.getRegionNameFromId({ regionsData: this.props.regionsData, id: this.props.selectedRegionId })
	  return (
	    <div className="ork-indicators-filters__col ork-indicators-filters__reference-regions">
	      <OverlayTrigger placement="left" overlay={this.tooltip}>
	        <div className="ork-indicators-filters__col__more-info" onClick={this.openReferenceRegionsModal}>
	          <i className="fal fa-lg fa-info-circle" />
	        </div>
	      </OverlayTrigger>
	      <div className="checkbox">
	        <CheckBoxFilter label={this.formatMessage(messages.showReferenceRegions)} fn={this.manageReference} checked={this.state.referenceRegions} />
	      </div>
	      <FilterModal
	        type="reference"
	        regionsData={regionsData}
	        open={this.state.showReferenceRegionsModal}
	        closeModal={this.closeReferenceRegionsModal}
	        regionName={regionName}
	      />
	    </div>
	  )
	}
	openReferenceRegionsModal = () => {
	  this.setState({ showReferenceRegionsModal: true })
	}
	closeReferenceRegionsModal = () => {
	  this.setState({ showReferenceRegionsModal: false })
	}

	showSameCountryRegionsFilter() {
	  return (
	    <div className="ork-indicators-filters__col ork-indicators-filters__ccaa">
	      <div className="checkbox">
	        <CheckBoxFilter
	          label={this.formatMessage(messages.showSameCountryRegions)}
	          fn={this.manageSameCountry}
	          checked={this.state.sameCountryRegions}
	        />
	      </div>
	    </div>
	  )
	}

	showTypeAheadFilter() {
	  return (
	    <div className="ork-indicators-filters__col">
	      <div className="form-group">
	        <label>{this.formatMessage(messages.compareWith)}</label>
	        <TypeAheadFilter fn={this.manageTypeAhead} regionsData={this.props.regionsData} multiple={this.props.typeAheadMultiple} />
	      </div>
	    </div>
	  )
	}

	showEvolutionFilter() {
	  return (
	    <div className="ork-indicators-filters__col">
	      <div className="form-group">
	        <EvolutionFilter fn={this.manageEvolution} label={this.formatMessage(messages.evolutionSince)} />
	      </div>
	    </div>
	  )
	}
	showChartTypeFilter() {
	  return (
	    <div className="ork-graphic-type-changing">
	      <span className="ork-graphic-type-changing__label">{this.formatMessage(messages.chartType)}:</span>
	      <ChartTypeFilter fn={this.manageChartType} />
	    </div>
	  )
	}

	render() {
	  return (
	    <div className="panel ork-u-mt-2">
	      <div className="panel-body ork-indicators-filters-wrapper">
	        <h3 className="h4 ork-u-mt-0">{this.formatMessage(messages.visualizationOptions)}</h3>
	        <div className={`ork-indicators-filters ork-indicators-filters--capa${this.props.layer}`}>
	          {this.showAllRegionsFilter()}
	          {/* {this.showReferenceRegionsFilter()} */}
	          {this.showSameCountryRegionsFilter()}
	          {this.showTypeAheadFilter()}
	          {/* {this.showEvolutionFilter()} */}
	        </div>
	        {this.showChartTypeFilter()}
	      </div>
	    </div>
	  )
	}
}

export default injectIntl(FilterContainer)



// WEBPACK FOOTER //
// ./src/modules/Filters/FilterContainer/FilterContainer.jsx